import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';
import { useJtTokenWatchdog } from '../../hooks/useJtTokenWatchdog';

export function AuthGuard({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());

  // Watchdog must run regardless of whether we end up rendering children —
  // calling it conditionally would violate the rules of hooks. It self-
  // gates on the presence of both an Engage JWT and a JT token.
  useJtTokenWatchdog();

  if (!isAuthenticated) {
    const loginPath = import.meta.env.DEV ? '/dev-login' : '/auth/callback';
    return <Navigate to={loginPath} replace />;
  }

  return <>{children}</>;
}
